import React from 'react'
import OrderStatus from './OrderStatus'
import SelectRestaurant from './SelectRestaurant'
import { format } from 'date-fns'
import FriendLabel from '../community/FriendLabel'

export const shortFormat = 'h:mm A'

const Delivery = ({
  delivery,
  selectDelivery,
  friendHasOrdered,
  locationId
}) => {
  const soldOut = delivery.weightLeft < 1
  const hurry = delivery.weightLeft < 7 && !soldOut
  return (
    <div className="todaysstores-item">
      <Logo storeName={delivery.restaurantName} logoLink={delivery.logoUrl} />
      <div className="todaysstores-item_content">
        <div className="restaurantTitle center-xs start-sm">
          {delivery.restaurantName}
        </div>
        <DeliveryTime
          deliveryTime={delivery.dropoffDate}
          tooLate={delivery.isPastCutoff}
          soldOut={soldOut}
        />
        <CutOffTime
          cutOffTime={delivery.cutoffDate}
          tooLate={delivery.isPastCutoff}
          soldOut={soldOut}
        />
        <div className="row">
          <SelectRestaurant
            locationId={locationId}
            tooLate={delivery.isPastCutoff}
            delivery={delivery}
            selectDelivery={selectDelivery}
            soldOut={soldOut}
          />
          <OrderStatus
            mealCount={delivery.weightLeft}
            hurry={hurry}
            tooLate={delivery.isPastCutoff && !soldOut}
            soldOut={soldOut}
          />
          <TooLateExplained
            cutoffTime={delivery.cutoffDate}
            tooLate={delivery.isPastCutoff}
            soldOut={soldOut}
          />
        </div>
        {friendHasOrdered &&
          friendHasOrdered.friends.slice(0, 5).map((friend, index) => (
            <div className="friendLabel" key={index}>
              <FriendLabel
                classNames={{ friendIconWrapper: true }}
                firstName={friend.firstName}
                lastName={friend.lastName}
                email={friend.email}
                showName={false}
                showEmail={false}
              />
            </div>
          ))}
        {friendHasOrdered && friendHasOrdered.friends.length > 5 && (
          <span> + {friendHasOrdered.friends.length - 5} more</span>
        )}
      </div>
    </div>
  )
}

export default Delivery

export const TooLateExplained = ({
  cutoffTime,
  tooLate,
  orderPlaced,
  soldOut
}) => (
  <div className="col-xs-12 center-xs start-sm">
    {tooLate && !orderPlaced && !soldOut && (
      <p>
        This restaurant requires orders to be placed by&nbsp;
        {format(cutoffTime, shortFormat)}.
      </p>
    )}
  </div>
)

export const Logo = ({ storeName, logoLink }) => (
  <div className="todaysstores-item_logo">
    <img
      className="todaysstores-item_logo-img"
      src={logoLink}
      alt={`${storeName} logo`}
    />
  </div>
)

export const DeliveryTime = ({ deliveryTime, tooLate, soldOut }) => (
  <div className="row todaysstores-item_orderby">
    {!tooLate && !soldOut && (
      <div className="col-xs-12 center-xs start-sm">
        Delivery Time:&nbsp;<strong>{format(deliveryTime, shortFormat)}</strong>
      </div>
    )}
  </div>
)

export const CutOffTime = ({ cutOffTime, tooLate, orderPlaced, soldOut }) => (
  <div className="row todaysstores-item_cutoff">
    {!tooLate && !orderPlaced && !soldOut && (
      <div className="col-xs-12 center-xs start-sm">
        Order By:&nbsp;<strong>{format(cutOffTime, shortFormat)}</strong>
      </div>
    )}
  </div>
)
